// Адреса соседнего приложения («Интеллект»).
//
// Единственное место, где они задаются. Раньше их писали по месту, каждый раз
// заново, и дважды по-разному: рядом с корректной development/production
// развилкой стояла ссылка, где локальный адрес разработчика был подставлен
// безусловно, — и уехала в прод. В собранном бандле на assessment.ezspeech.ai
// действительно лежит http://intellect.local.test:5200.
//
// Значение по умолчанию — продовое. Так забытая переменная окружения ломает
// локальную разработку (это видно сразу), а не живой сайт.

const INTELLECT_BASE_URL = (
  process.env.REACT_APP_INTELLECT_URL || 'https://intellect.ezspeech.ai'
).replace(/\/+$/, '');

// from_assessment=true говорит «Интеллекту», что через логин уже проходили:
// если общей куки всё равно нет, он покажет ошибку вместо повторного
// редиректа сюда (иначе браузер зациклится между двумя хостами).
const INTELLECT_TASKS_URL = `${INTELLECT_BASE_URL}/tasks?from_assessment=true`;

export { INTELLECT_BASE_URL, INTELLECT_TASKS_URL };
